'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            roadElements: '=',
            showParkingObjects: '=',
            parkingObjects: '=',
            showPublicTransportStopObjects: '=',
            publicTransportStopObjects: '=',
            showAkis: '<',
            showOpis: '<'
        },
        bindToController: true,
        controllerAs: 'vm',
        template: require('./road-elements-map.directive.html'),
        /*@ngInject*/
        controller: function controller($scope, mapService, roadElementsService, $sce, $rootScope, $uibModal) {
            var vm = this;
            vm.isMapView = true;
            vm.mapLoaded = false;
            vm.roadElementDataModalOpen = false;
            vm.selectedRoadElementId = undefined;
            vm.akisOpisOpen = false;
            vm.akisOpisData = undefined;
            vm.mapUrlsLoaded = false;
            vm.rootscope = $rootScope;
            vm.url = '';
            vm.mapSource = '';

            vm.objectUrl = '';
            vm.roadElementPathUrl = '';
            vm.roadElementObstacleUrl = '';
            vm.routeUrl = '';

            $scope.$watch(function () {
                return vm.roadElements;
            }, function (val) {
                if (vm.mapLoaded) {
                    vm.filterData();
                }
            });

            $scope.$watch(function () {
                return vm.showParkingObjects;
            }, function (val) {
                if (vm.mapLoaded) {
                    vm.filterData();
                }
            });

            $scope.$watch(function () {
                return vm.showPublicTransportStopObjects;
            }, function (val) {
                if (vm.mapLoaded) {
                    if (vm.showPublicTransportStopObjects) {
                        vm.postMessage({ type: 'show-layers', url: vm.busStopUrl });
                    } else {
                        vm.postMessage({ type: 'hide-layers', url: vm.busStopUrl });
                    }
                }
            });
            $scope.$watch(function () {
                return vm.showAkis;
            }, function (val) {
                if (vm.mapLoaded) {
                    if (vm.showAkis) {
                        vm.postMessage({ type: 'show-layers', url: vm.akisUrl });
                    } else {
                        vm.postMessage({ type: 'hide-layers', url: vm.akisUrl });
                    }
                }
            });

            $scope.$watch(function () {
                return vm.showOpis;
            }, function (val) {
                if (vm.mapLoaded) {
                    if (vm.showOpis) {
                        vm.postMessage({ type: 'show-layers', url: vm.opisUrl });
                    } else {
                        vm.postMessage({ type: 'hide-layers', url: vm.opisUrl });
                    }
                }
            });

            vm.$onInit = function () {
                var mapUrls = vm.rootscope.mapUrls;

                vm.objectUrl = mapUrls.objectUrl;
                vm.roadElementPathUrl = mapUrls.roadElementPathUrl;
                vm.roadElementObstacleUrl = mapUrls.roadElementObstacleUrl;
                vm.routeUrl = mapUrls.routeUrl;
                vm.busStopUrl = mapUrls.busStopUrl;
                vm.akisUrl = mapUrls.akisUrl;
                vm.opisUrl = mapUrls.opisUrl;
                vm.mapSource = mapUrls.mapUrl;

                vm.url = $sce.trustAsResourceUrl(vm.mapSource + '?init=[{"type":"filter","ids":[],"url":' + JSON.stringify(vm.roadElementPathUrl) + ',"zoomTo":false},{"type":"filter","ids":[],"url":' + JSON.stringify(vm.roadElementObstacleUrl) + ',"zoomTo":false},{"type":"filter","ids":[],"url":' + JSON.stringify(vm.objectUrl) + ',"zoomTo":false},{"type":"hide-layers","url":' + JSON.stringify(vm.routeUrl + ',' + vm.busStopUrl) + '}]');

                vm.mapUrlsLoaded = true;
            };

            var unsub = mapService.subscribe(function (data) {
                if (data.type === 'ready') {
                    vm.mapLoaded = true;
                    vm.filterData();
                    vm.enableIdentify();

                    roadElementsService.getPreviewId().then(function (result) {
                        if (result.data) {
                            vm.selectedRoadElementId = result.data;
                            vm.roadElementDataModalOpen = true;
                            vm.rootscope.isModalOpen = true;
                        }
                    });
                }

                if (data.url && data.type === 'identify-result') {
                    if (data.url.includes(vm.opisUrl) || data.url.includes(vm.akisUrl)) {
                        vm.rootscope.openAkisOpisModal(data);
                    } else {
                        angular.forEach(vm.roadElements, function (roadElement) {
                            if (roadElement.gis_id === data.id) {
                                $uibModal.open({
                                    template: require('./road-element-data-modal.directive.html'),
                                    controller: require('./road-element-data-modal.directive'),
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    backdrop: 'static',
                                    keyboard: false,
                                    windowClass: 'center-modal',
                                    resolve: {
                                        data: function data() {
                                            return roadElement.road_element;
                                        }
                                    }
                                });
                                vm.rootscope.isModalOpen = true;
                            }
                        });
                    }
                }
            });

            $scope.$on('$destroy', function () {
                return unsub();
            });

            vm.filterData = function () {
                var object_gis_ids = [];
                if (vm.showParkingObjects && vm.parkingObjects) {
                    angular.forEach(vm.parkingObjects, function (parkingObject) {
                        object_gis_ids.push(parkingObject);
                    });
                }
                //
                // const bus_stop_gis_ids = [];
                // if (vm.showPublicTransportStopObjects && vm.publicTransportStopObjects) {
                //     angular.forEach(vm.publicTransportStopObjects, function (publicTransportStopObject) {
                //         bus_stop_gis_ids.push(publicTransportStopObject);
                //     });
                // }

                vm.postFilter(object_gis_ids, vm.objectUrl);
                // vm.postFilter(bus_stop_gis_ids, vm.busStopUrl);
                vm.postFilter(vm.getRoadElementGisIdsByGeometryType('DOT_OBJECT'), vm.roadElementObstacleUrl);
                vm.postFilter(vm.getRoadElementGisIdsByGeometryType('LINE_OBJECT'), vm.roadElementPathUrl);
            };

            vm.getRoadElementGisIdsByGeometryType = function (geometryType) {
                var gis_ids = [];
                angular.forEach(vm.roadElements, function (roadElement) {
                    if (roadElement.geometry_type === geometryType) {
                        gis_ids.push(roadElement.gis_id);
                    }
                });
                return gis_ids;
            };

            vm.postFilter = function (ids, url) {
                vm.postMessage({ type: 'filter', ids: ids, url: url, zoomTo: false });
            };

            vm.enableIdentify = function () {
                var url = vm.roadElementObstacleUrl + ',' + vm.roadElementPathUrl + ',' + vm.akisUrl + ',' + vm.opisUrl;
                vm.postMessage({ type: 'enable-identify', url: url });
            };

            vm.removeFilter = function () {
                vm.postMessage({ type: 'remove-filter' });
            };

            vm.postMessage = function (message) {
                return document.getElementById('map').contentWindow.postMessage(message, vm.mapSource);
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/road_elements/road-elements-map.directive.js
 **/